import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { truncateUrl } from "common/helper";
import { useSnackbar } from "notistack";
import { ModalBody, ModalFooter } from "application/modal/index";
import { useModelPopup } from "common/hooks";
import { addDocument } from "common/actions/common.action";

import { Button, BtnType, Loading, Label } from "../../../../../primitives";

const AddDocumentLink = () => {
  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    projectsReducer: {
      projectReducer: { selectedProject },
    },
    documentsReducer: { loadingDocs },
  } = useSelector((state) => state);
  const popup = useModelPopup();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const [docLink, setDocLink] = useState("");
  const [docTitle, setDocTitle] = useState("");

  const addDocumentLink = () => {
    const obj = {
      description: docLink,
      name: docTitle || truncateUrl(docLink),
      s3url: docLink,
      councilId: selectedCouncil.id,
      document_resource_type: "Project",
      document_resource_id: selectedProject.id,
      added_by_id: session.id,
      enqueueSnackbar,
      upload_type: "link",
    };
    dispatch(addDocument(obj));
  };

  if (loadingDocs) {
    return <Loading />;
  }
  return (
    <div>
      <ModalBody>
        <Label>Title</Label>

        <input
          className="w-100 border small p-2 mb-3"
          placeholder="Add title"
          onChange={(evt) => setDocTitle(evt.target.value)}
        />
        <Label>Link</Label>
        <input
          className="w-100 border small p-2 mb-3"
          placeholder="Add title"
          onChange={(evt) => setDocLink(evt.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            popup.hide();
          }}
          btn={BtnType.FRAME_LESS}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            addDocumentLink(docLink, docTitle);
            popup.hide();
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </div>
  );
};

export default AddDocumentLink;
